import React from 'react';
//import { styled } from '@material-ui/core/styles';
import {
    //CalendarTodayOutlined as DateIcon,
    AccessTimeOutlined as TimeIcon,
} from '@material-ui/icons';

import { ReactComponent as DateIconSvg } from "../../assets/icons/pcr/date.svg";
import Tab1IconSvg from "../../assets/icons/pcr/tab_1.svg";
import Tab2IconSvg from "../../assets/icons/pcr/tab_2.svg";
import Tab3IconSvg from "../../assets/icons/pcr/tab_3.svg";
import Tab4IconSvg from "../../assets/icons/pcr/tab_4.svg";
import Tab5IconSvg from "../../assets/icons/pcr/tab_5.svg";
import Tab6IconSvg from "../../assets/icons/pcr/tab_6.svg";
import Tab7IconSvg from "../../assets/icons/pcr/tab_7.svg";
import Tab8IconSvg from "../../assets/icons/pcr/tab_8.svg";
import Tab9IconSvg from "../../assets/icons/pcr/tab_9.svg";
import Tab10IconSvg from "../../assets/icons/pcr/tab_10.svg";

import Type1IconSvg from "../../assets/icons/pcr/type_1.svg";
import Type2IconSvg from "../../assets/icons/pcr/type_2.svg";
import Type3IconSvg from "../../assets/icons/pcr/type_3.svg";

import DropDownIconSvg from "../../assets/icons/pcr/dropdown.svg";
import UserListIconSvg from "../../assets/icons/pcr/user_list.svg";
import ThankYouIconSvg from "../../assets/icons/pcr/thank_you.svg";
import ThankYouTickIconSvg from "../../assets/icons/pcr/tick.svg";
import BackLightIconSvg from "../../assets/icons/pcr/back_light.svg";
import DeleteLightIconSvg from "../../assets/icons/pcr/delete_light.svg";
import DeleteIconSvg from "../../assets/icons/pcr/delete.svg";
import SubmitIconSvg from "../../assets/icons/pcr/submit.svg";
import IncidentIconSvg from "../../assets/icons/pcr/incident.svg";
import RemoveIconSvg from "../../assets/icons/pcr/remove.svg";
import CloseIconSvg from "../../assets/icons/pcr/close.svg";
import CloseLightIconSvg from "../../assets/icons/pcr/close_light.svg";
import PhotoIconSvg from "../../assets/icons/pcr/photo.svg";
import AlertLightIconSvg from "../../assets/icons/pcr/alert_light.svg";
import RemoveCircleIconSvg from "../../assets/icons/pcr/remove_circle.svg";
import HelpIconSvg from "../../assets/icons/pcr/help.svg";
import PulseLightIconSvg from "../../assets/icons/pcr/pulse_light.svg";
import AlteredUpIconSvg from "../../assets/icons/pcr/altered_up.svg";
import AlteredDownIconSvg from "../../assets/icons/pcr/altered_down.svg";
import AcuityIconSvg from "../../assets/icons/pcr/acuity.svg";
import RedHelpIconSvg from "../../assets/icons/pcr/Redhelp.svg";

import { ReactComponent as PainScore0IconSvg } from "../../assets/icons/pcr/pain_score_0.svg";
import { ReactComponent as PainScore2IconSvg } from "../../assets/icons/pcr/pain_score_2.svg";
import { ReactComponent as PainScore4IconSvg } from "../../assets/icons/pcr/pain_score_4.svg";
import { ReactComponent as PainScore6IconSvg } from "../../assets/icons/pcr/pain_score_6.svg";
import { ReactComponent as PainScore8IconSvg } from "../../assets/icons/pcr/pain_score_8.svg";
import { ReactComponent as PainScore10IconSvg } from "../../assets/icons/pcr/pain_score_10.svg";
import { ReactComponent as CaregiversIconSvg } from "../../assets/icons/pcr/caregivers.svg";

// date & time pickers
export const DatePickerIcon = (props: any) => {
    return (
        <DateIconSvg {...props} />
    );
}
export const TimePickerIcon = (props: any) => {
    return (
        <TimeIcon {...props} style={{ color: "#00142e", fontSize: "22px" }} />
    );
}

// tabs
export const Tab1Icon = (props: any) => {
    return (
        <img src={Tab1IconSvg} alt="" {...props} />
    );
}
export const Tab2Icon = (props: any) => {
    return (
        <img src={Tab2IconSvg} alt="" {...props} />
    );
}
export const Tab3Icon = (props: any) => {
    return (
        <img src={Tab3IconSvg} alt="" {...props} />
    );
}
export const Tab4Icon = (props: any) => {
    return (
        <img src={Tab4IconSvg} alt="" {...props} />
    );
}
export const Tab5Icon = (props: any) => {
    return (
        <img src={Tab5IconSvg} alt="" {...props} />
    );
}
export const Tab6Icon = (props: any) => {
    return (
        <img src={Tab6IconSvg} alt="" {...props} />
    );
}
export const Tab7Icon = (props: any) => {
    return (
        <img src={Tab7IconSvg} alt="" {...props} />
    );
}
export const Tab8Icon = (props: any) => {
    return (
        <img src={Tab8IconSvg} alt="" {...props} />
    );
}
export const Tab9Icon = (props: any) => {
    return (
        <img src={Tab9IconSvg} alt="" {...props} />
    );
}
export const Tab10Icon = (props: any) => {
    return (
        <img src={Tab10IconSvg} alt="" {...props} />
    );
}

// types
export const Type1Icon = (props: any) => {
    return (
        <img src={Type1IconSvg} alt="" {...props} />
    );
}
export const Type2Icon = (props: any) => {
    return (
        <img src={Type2IconSvg} alt="" {...props} />
    );
}
export const Type3Icon = (props: any) => {
    return (
        <img src={Type3IconSvg} alt="" {...props} />
    );
}

// others
export const RequiredIcon = () => {
    return (
        <>
            <svg className="required" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 11 10" style={{ marginLeft: -15, marginRight: 5 }}>
                <path id="_copy" data-name="* copy" d="M7.961,10,9.444,8.9,7.056,5.658,11,4.306,10.276,2.6,6.4,4.021V0H4.487V4.021L.651,2.6,0,4.306,3.836,5.658,1.484,8.9,3.112,10,5.464,6.584Z" fill="#f4b827" />
            </svg>
        </>
    );
}
export const FieldSlashIcon = () => {
    return (
        <>
            <div style={{ fontSize: 32, paddingLeft: 5, paddingRight: 5, textAlign: 'center', display: 'inline', color: '#757575' }}>
                /
            </div>
        </>
    );
}
export const DropDownIcon = (props: any) => {
    return (
        <img src={DropDownIconSvg} alt="" />
    );
}
export const UserListIcon = (props: any) => {
    return (
        <img src={UserListIconSvg} alt="" {...props} />
    );
}
export const ThankYouIcon = (props: any) => {
    return (
        <img src={ThankYouIconSvg} alt="" {...props} />
    );
}
export const ThankYouTickIcon = (props: any) => {
    return (
        <img src={ThankYouTickIconSvg} alt="" {...props} />
    );
}
export const BackLightIcon = (props: any) => {
    return (
        <img src={BackLightIconSvg} alt="" {...props} />
    );
}
export const DeleteLightIcon = (props: any) => {
    return (
        <img src={DeleteLightIconSvg} alt="" {...props} />
    );
}
export const DeleteIcon = (props: any) => {
    return (
        <img src={DeleteIconSvg} alt="" {...props} />
    );
}
export const SubmitIcon = (props: any) => {
    return (
        <img src={SubmitIconSvg} alt="" {...props} />
    );
}
export const IncidentIcon = (props: any) => {
    return (
        <img src={IncidentIconSvg} alt="" {...props} />
    );
}
export const RemoveIcon = (props: any) => {
    return (
        <img src={RemoveIconSvg} alt="" {...props} />
    );
}
export const CloseIcon = (props: any) => {
    return (
        <img src={CloseIconSvg} alt="" {...props} />
    );
}
export const CloseLightIcon = (props: any) => {
    return (
        <img src={CloseLightIconSvg} alt="" {...props} />
    );
}
export const PhotoIcon = (props: any) => {
    return (
        <img src={PhotoIconSvg} alt="" {...props} />
    );
}
export const AlertLightIcon = (props: any) => {
    return (
        <img src={AlertLightIconSvg} alt="" {...props} />
    );
}
export const RemoveCircleIcon = (props: any) => {
    return (
        <img src={RemoveCircleIconSvg} alt="" {...props} />
    );
}
export const HelpIcon = (props: any) => {
    return (
        <img src={HelpIconSvg} alt="" {...props} />
    );
}
export const RedHelpIcon = (props: any) => {
    return (
        <img src={RedHelpIconSvg} alt="" {...props} />
    );
}
export const PulseLightIcon = (props: any) => {
    return (
        <img src={PulseLightIconSvg} alt="" {...props} />
    );
}
export const AlteredUpIcon = (props: any) => {
    return (
        <img src={AlteredUpIconSvg} alt="" {...props} />
    );
}
export const AlteredDownIcon = (props: any) => {
    return (
        <img src={AlteredDownIconSvg} alt="" {...props} />
    );
}
export const AcuityIcon = (props: any) => {
    return (
        <img src={AcuityIconSvg} alt="" {...props} />
    );
}

export const PainScore0Icon = (props: any) => {
    return (
        <PainScore0IconSvg {...props} />
    );
}
export const PainScore2Icon = (props: any) => {
    return (
        <PainScore2IconSvg {...props} />
    );
}
export const PainScore4Icon = (props: any) => {
    return (
        <PainScore4IconSvg {...props} />
    );
}
export const PainScore6Icon = (props: any) => {
    return (
        <PainScore6IconSvg {...props} />
    );
}
export const PainScore8Icon = (props: any) => {
    return (
        <PainScore8IconSvg {...props} />
    );
}
export const PainScore10Icon = (props: any) => {
    return (
        <PainScore10IconSvg {...props} />
    );
}

export const CaregiversIcon = (props: any) => {
    return (
        <CaregiversIconSvg {...props} />
    );
}
